'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasAgentReplyFromCurrentSession = undefined;

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _isFromAgent = require('../../pubnub-message/operators/isFromAgent');

var _getMessageIsApproximatelyFromCurrentSession = require('../../pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('./hasMessages');

var _getMessages = require('./getMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAgentReplyFromCurrentSession = exports.hasAgentReplyFromCurrentSession = function hasAgentReplyFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var mostRecentAgentReply = messages.findLast((0, _both2.default)(function (message) {
    return !(0, _messageTypeComparators.isInitialMessage)(message);
  }, _isFromAgent.isFromAgent));

  return !!(mostRecentAgentReply && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(mostRecentAgentReply));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasAgentReplyFromCurrentSession.js
// module id = 755
// module chunks = 2 3